import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net';
import { useLocation, useNavigate } from "react-router";
import baseConfig from "../../core/config/Config";
import {CardService} from "./Service";
import toast from "react-hot-toast";



const ManageCards = () => {
    const [service] = useState(new CardService());
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        try {
            $('#table').DataTable().destroy();
        } catch (e) {
            console.log(e);
        }
        let token = localStorage.getItem('token')
        $('#table').DataTable({
            lengthMenu: [10, 20, 50, 100, 500, 1000],
            pageLength: 100,
            processing: true,
            serverSide: true,
            columnDefs: [
                {

                    "render": function (data, type, row) {
                        return `<b>@${data}</b>`
                    },
                    "createdCell": (td, cellData, rowData, row, col) => {

                    },
                    "targets": 0
                },
                {

                    "render": function (data, type, row) {
                        return `<b>#${data}</b>`
                    },
                    "createdCell": (td, cellData, rowData, row, col) => {

                    },
                    "targets": 2
                },
                // {
                //
                //     "render": function (data, type, row) {
                //         return `<button class="btn btn-primary">Details</button>`;
                //     },
                //     "createdCell": (td, cellData, rowData, row, col) => {
                //         $(td).click(e => {
                //             // console.log('CLICKED');
                //             navigate(`${location.pathname}/details/${cellData}`);
                //         })
                //     },
                //     "targets": 6
                // },
            ],
            ajax: {
                url: `${baseConfig.apiBaseUrl}/card/list`,
                type: "POST",
                contentType: "application/json",
                headers: {
                    "Authorization": token,
                },
                data: function (d) {
                    return JSON.stringify(d);
                },
            }
        });
    }

    return (
        <div>

            <div className="card mt-3">
                <div className="card-header p-3">
                    <h5 className="card-title">Manage Cards</h5>
                </div>
                <div className="card-body">
                    <div className='table-responsive w-100'>
                        <table
                            id="table"
                            className='table datatable w-100'
                        >
                            <thead>
                            <tr>
                                <th>Username</th>
                                <th>User</th>
                                <th>OrderId</th>
                                <th>Link</th>
                                <th>Purchase Date</th>
                                <th>Last Updated</th>
                                {/*<th>Details</th>*/}
                            </tr>
                            </thead>
                            <tbody>
                            </tbody>
                        </table>
                    </div>


                </div>
            </div>
        </div>
    );
}

export default ManageCards;
